import React from 'react'
import { strings } from '../../localization/strings'
import ContactForm from '../pages/contactForm'
import RegistrationForm from '../pages/registrationForm'
import LogIn from '../pages/logIn'
import ChangePassword from '../pages/changePassword'
import Tracking from '../pages/tracking'
import ResetPassword from '../pages/reset_password'
import ShopifyAuthResult from '../pages/shopify/authResult'
import ShopifyLogIn from '../pages/shopify/logIn'
import TiendanubeAutorize from '../pages/tiendanube/autorize'
import wooCommerce from '../pages/wooCommerce'
import Orders from '../pages/orders'
import TrackingForm from '../pages/trackingForm'
import Eula from '../pages/eula'
import ViewEula from '../pages/vieweula'
import Contact from '../pages/contact'
import LockerMap from '../pages/lockerMap'
import BillingInformation from '../pages/billing-information'
import OrderNew from '../pages/orderNew'
import ImportSheetFile from '../pages/importSheetFile'
import DispatchToLocker from '../pages/dispatchToLocker'
import Config from '../pages/config'
import Price from '../pages/price'
import WooCommerceHelp from '../pages/wooCommerceHelp'
import ShopifyHelp from '../pages/shopifyHelp'
import ListAltIcon from '@material-ui/icons/ListAlt'
import DescriptionIcon from '@material-ui/icons/Description'
import SettingsIcon from '@material-ui/icons/Settings'
import LockerMapIcon from '@material-ui/icons/Room'
import ContactMailIcon from '@material-ui/icons/ContactMail'
import ContactSupportIcon from '@material-ui/icons/ContactSupport'
import ReceiptIcon from '@material-ui/icons/Receipt'
import { BoxAddIcon, BoxDispatchIcon, BoxPickupIcon } from '../components/icons'
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn'
import LocalShippingIcon from '@material-ui/icons/LocalShipping'
import ServiceAreaConfig from '../pages/serviceAreaConfig'
import ReverseLogistics from '../pages/reverseLogistics'
import Movements from '../pages/billing-movements'
import NoteAddIcon from '@material-ui/icons/NoteAdd'
import CriticalNews from '../pages/news/criticalNews'
import RestrictiveNew from '../pages/news/restrictiveNews'
import EcommerceDocumentation from '../pages/documentation/ecommerceDocumentation/ecommerceDocumentation'

export const routes = {
    orders: {
        path: '/orders',
        component: Orders,
        title: strings.ordersTitle,
        requireAuth: true,
        toolbar: {
            drawerButton: true,
            profileButton: true,
            newsButton: true,
        },
        icon: <ListAltIcon />,
        drawerOrder: 1,
    },

    orderNew: {
        path: '/orderNew',
        component: OrderNew,
        title: strings.orderNewTitle,
        requireAuth: true,
        toolbar: {
            drawerButton: true,
        },
        icon: <BoxAddIcon />,
        drawerOrder: 2,
    },

    orderImporter: {
        path: '/orderImporter',
        component: ImportSheetFile,
        title: strings.importSheetFile,
        requireAuth: true,
        toolbar: {
            drawerButton: true,
            profileButton: true,
            newsButton: true,
            },
        icon: <NoteAddIcon />,
        drawerOrder: 3,
    },

    reverseLogistics: {
        path: '/reverseLogistics',
        component: ReverseLogistics,
        title: strings.reverseLogisticsNewTitle,
        requireAuth: true,
        toolbar: {
            drawerButton: true,
        },
        icon: <BoxPickupIcon />,
        drawerOrder: 4,
    },

    dispatchToLocker: {
        path: '/dispatchToLocker',
        component: () => <DispatchToLocker />,
        title: strings.dispatchToLockerTitle,
        requireAuth: true,
        toolbar: {
            drawerButton: true,
        },
        icon: <BoxDispatchIcon />,
        drawerOrder: 5,
    },

    lockerMap: {
        path: '/lockerMap',
        component: LockerMap,
        title: strings.lockersMapFormTitle,
        requireAuth: true,
        toolbar: {
            backButton: false,
            drawerButton: true,
            profileButton: false,
        },
        icon: <LockerMapIcon />,
        drawerOrder: 6,
    },

    price: {
        path: '/price',
        component: Price,
        title: strings.priceTitle,
        requireAuth: true,
        toolbar: {
            backButton: false,
            drawerButton: true,
            profileButton: false,
        },
        icon: <MonetizationOnIcon />,
        drawerOrder: 7,
    },

    serviceAreaConfig: {
        path: '/serviceAreaConfig',
        component: ServiceAreaConfig,
        title: strings.serviceAreaConfigTitle,
        requireAuth: true,
        toolbar: {
            backButton: false,
            drawerButton: true,
            profileButton: false,
        },
        icon: <LocalShippingIcon />,
        drawerOrder: 8,
    },

    billingInformation: {
        path: '/billingInformation',
        component: BillingInformation,
        title: strings.billingInformation_title,
        requireAuth: true,
        toolbar: {
            backButton: false,
            drawerButton: true,
            profileButton: false,
        },
        icon: <ContactMailIcon />,
        drawerOrder: 9,
    },

    movements: {
        path: '/movements',
        component: Movements,
        title: strings.movements_title,
        requireAuth: true,
        toolbar: {
            backButton: false,
            drawerButton: true,
            profileButton: false,
        },
        icon: <ReceiptIcon />,
        drawerOrder: 10,
    },

    config: {
        path: '/config',
        component: Config,
        title: strings.configTitle,
        requireAuth: true,
        toolbar: {
            backButton: false,
            drawerButton: true,
            profileButton: false,
        },
        icon: <SettingsIcon />,
        drawerOrder: 11,
    },

    vieweula: {
        path: '/vieweula',
        component: ViewEula,
        title: strings.eulaTitle,
        requireAuth: true,
        toolbar: {
            backButton: false,
            drawerButton: true,
            profileButton: false,
        },
        icon: <DescriptionIcon />,
        drawerOrder: 12,
    },

    contact: {
        path: '/contact',
        component: Contact,
        title: strings.contactTitle,
        requireAuth: true,
        toolbar: {
            backButton: false,
            drawerButton: true,
            profileButton: false,
        },
        icon: <ContactSupportIcon />,
        drawerOrder: 13,
    },

    resetPassword: {
        path: '/resetPassword',
        component: ResetPassword,
        title: strings.resetPasswordFormTitle,
        requireAuth: false,
    },

    logIn: {
        path: '/logIn',
        component: LogIn,
        requireAuth: false,
    },

    ecommerceDocumentation: {
        path: '/ecommerceDocumentation',
        component: EcommerceDocumentation,
        title: strings.ecommerceDocumentation,
        requireAuth: false,
    },

    tiendanubeAutorize: {
        path: '/tiendaNubeAutorize',
        component: TiendanubeAutorize,
        title: strings.tiendanubeAutorizeTitle,
        requireAuth: false,
    },

    wooCommerceStatus: {
        path: '/wooCommerceResult',
        component: wooCommerce,
        title: strings.wooCommerceTitle,
        requireAuth: false,
    },

    wooCommerceHelp: {
        path: '/WooCommerceHelp',
        component: WooCommerceHelp,
        title: strings.wooCommerceHelpTitle,
        requireAuth: false,
        toolbar: {
            backButton: true,
        },
    },

    shopifyHelp: {
        path: '/ShopifyHelp',
        component: ShopifyHelp,
        title: strings.shopifyHelpTitle,
        requireAuth: false,
        toolbar: {
            backButton: true,
        },
    },

    shopifyLogIn: {
        path: '/shopifyLogIn',
        component: ShopifyLogIn,
        title: strings.shopifyLogInTitle,
        requireAuth: false,
    },

    shopifyAuthResult: {
        path: '/shopifyAuthResult',
        component: ShopifyAuthResult,
        title: strings.shopifyAuthResultTitle,
        requireAuth: false,
    },

    contactForm: {
        path: '/contactForm',
        component: ContactForm,
        title: strings.contactFormTitle,
        toolbar: {
            backButton: true,
            drawerButton: false,
            profileButton: false,
        },
        requireAuth: false,
    },
    registrationForm: {
        path: '/registrationForm',
        component: RegistrationForm,
        title: strings.registrationFormTitle,
        requireAuth: false,
    },

    trackingForm: {
        path: '/trackingForm',
        component: TrackingForm,
        title: strings.trackingFormTitle,
        requireAuth: false,
    },

    changePassword: {
        path: '/changePassword',
        component: ChangePassword,
        title: strings.changePasswordTitle,
        requireAuth: true,
        toolbar: {
            backButton: true,
            profileButton: true,
        },
    },

    tracking: {
        path: '/tracking',
        component: Tracking,
        title: strings.trackingTitle,
        requireAuth: true,
        toolbar: {
            backButton: true,
            profileButton: true,
        },
    },

    criticalNews: {
        path: '/criticalNews',
        component: CriticalNews,
        // title: strings.eulaTitle,
        requireAuth: true,
    },

    restrictiveNew: {
        path: '/restrictiveNew',
        component: RestrictiveNew,
        requireAuth: true,
    },
    
    eula: {
        path: '/eula',
        component: Eula,
        title: strings.eulaTitle,
        requireAuth: true,
    },

    main: {
        path: '/',
        component: LogIn,
        requireAuth: false,
    },
}

export default routes
